import { number, ValidationError } from 'yup'
import { OrderAmountSlice } from './order-amount-types'
import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { makeOrderFrequencyInitialState } from '../frequency/order-frequency-utils'
import { INITIAL_STATE } from './order-amount-slice'
import { FREQUENCY } from '@classy/campaign-page-blocks'

export const ORDER_AMOUNT_ERROR_MESSAGE = 'Please, enter a valid amount'

export const getOrderAmountError = (value?: number) => {
  const schema = number().required().positive()

  let errorMessage = undefined

  try {
    schema.validateSync(value)
  } catch (err) {
    if (err instanceof ValidationError) {
      errorMessage = ORDER_AMOUNT_ERROR_MESSAGE
    }
  }

  return errorMessage
}

export const getOrderAmountInitialState = (
  config: Config,
  urlParams: URLParams,
): OrderAmountSlice => {
  let value = urlParams.amount || INITIAL_STATE.value

  // If there is an amount in the URL params, use that immediately
  if (value) {
    return { value, error: undefined }
  }

  // If Intelligent Ask Amounts, set the initial value to 0
  if (config.intelligentAsks?.isEnabled) {
    return { value: 0, error: undefined }
  }

  const frequency = makeOrderFrequencyInitialState(config, urlParams)

  if (config.iaa.useIntelligentAskOnetime && frequency.value === FREQUENCY.ONE_TIME) {
    return { value: 0, error: undefined }
  }

  if (config.iaa.useIntelligentAskRecurring && frequency.value !== FREQUENCY.ONE_TIME) {
    return { value: 0, error: undefined }
  }

  // If there is no amount in the URL params and no IAA, use the default preset amount
  if (!value) {
    config.amount.presets[frequency.value]?.forEach((option) => {
      if (option.isDefault) {
        value = option.amount
      }
    })
  }

  return { value, error: undefined }
}
